import { OrderDetailsResponseBack } from '../../../models';

export abstract class IOrderDetailsHttpService {
  abstract getOrderDetails(voucherCode: string, country: string): Promise<OrderDetailsResponseBack>;
}
